module.exports = __webpack_public_path__ + "static/Admin-e3fbdd292fc199711bf4e85641105a02.png";